import './style/leaveRequestPage.scss';

import React from 'react';
import Document from '../../../models/documentModel';
import {DocumentType} from '../../../util/enums';
import EditableHeader from '../../editor/editableHeader';
import EditablePar from '../../editor/editablePar';
import SiteDocument from '../../misc/siteDocument';
import useDocuments from '../../misc/useDocuments';

export default function LeaveRequestPage() {
    const [documents, loading] = useDocuments(DocumentType.LEAVE_FORM);

    function renderDocument(document: Document, index: number) {
        return <SiteDocument document={document} loading={loading} key={index}/>;
    }

    function renderDummyDocuments() {
        const dummies: Array<Document> = [
            new Document({file_name: 'a'}),
            new Document({file_name: 'a'}),
            new Document({file_name: 'a'}),
            new Document({file_name: 'a'}),
            new Document({file_name: 'a'})
        ];
        return dummies.map(renderDocument);
    }

    return (
        <main className='default-page leave-request-page'>
            <EditableHeader textKey='leave-head-1' className='page-title'/>
            <section className='section'>
                <EditableHeader textKey='leave-head-2' className='section-title' headerType='h2'/>
                <EditablePar textKey='leave-text-1' className='section-par'/>
                <div className='documents-container'>
                    {loading ? renderDummyDocuments() : documents.map(renderDocument)}
                </div>
            </section>
        </main>
    );
}